module.exports = __webpack_public_path__ + "static/media/B.582423c0.PNG";